/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';

export default class Address extends React.PureComponent {
  render() {
    const {
      title,
      city,
      mailOnly,
      address,
      telephoneNumber,
      faxNumber,
      isFooter,
    } = this.props;

    return (
      <li className="Address">
        {isFooter ? (
          <h4 className="Address__heading">
            <span
              className="Address__title"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </h4>
        ) : (
          <h2 className="Address__heading">
            <span
              className="Address__title"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </h2>
        )}
        <p className="Address__paragraph">
          <span
            className="Address__city"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: city }}
          />
          {mailOnly && (
            <small className="Address__mail-only">(mail only)</small>
          )}
        </p>
        <p
          className="Address__text"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: address }}
        />
        <p className="Address__text">
          <span>Tel:&nbsp;</span>
          <a
            href={`tel:${telephoneNumber}`}
            className="Address__link"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: telephoneNumber }}
          />
        </p>
        {faxNumber && (
          <p className="Address__text">
            <span>Fax:&nbsp;</span>
            <a
              href={`tel:${faxNumber}`}
              className="Address__link"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: faxNumber }}
            />
          </p>
        )}
      </li>
    );
  }
}

Address.propTypes = {
  title: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  mailOnly: PropTypes.bool,
  address: PropTypes.string.isRequired,
  telephoneNumber: PropTypes.string.isRequired,
  faxNumber: PropTypes.string,
  isFooter: PropTypes.bool,
};

Address.defaultProps = {
  mailOnly: false,
  faxNumber: '',
  isFooter: false,
};
